/* Diamond 4Cs visual blocks: color groups linked to the grade table, and the clarity loupe. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Color: groups <-> next table rows ---------- */
  function initColor(fig) {
    if (fig.__edu) return; fig.__edu = true;
    var stones = fig.querySelectorAll('.clr__stone');
    var bands = fig.querySelectorAll('.edu-fig__band');
    var rows = [];
    if (fig.hasAttribute('data-link-table')) {
      var el = fig.nextElementSibling;
      while (el && !el.classList.contains('policy-table')) {
        if (el.classList.contains('policy-sub') || el.classList.contains('policy-chapter') || el.classList.contains('edu-fig')) { el = null; break; }
        el = el.nextElementSibling;
      }
      if (el) { rows = el.querySelectorAll('tbody tr'); el.setAttribute('data-linked', ''); }
    }
    var locked = -1;
    function show(i) {
      fig.classList.toggle('has-band', i > -1);
      stones.forEach(function (s) { s.classList.toggle('is-on', +s.getAttribute('data-band') === i); });
      bands.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i && locked === i ? 'true' : 'false'); });
      for (var r = 0; r < rows.length; r++) rows[r].classList.toggle('is-linked', r === i);
    }
    function hover(i) { return function () { if (locked < 0) show(i); }; }
    function leave() { show(locked); }
    bands.forEach(function (b, i) {
      b.addEventListener('mouseenter', hover(i));
      b.addEventListener('mouseleave', leave);
      b.addEventListener('click', function () { locked = locked === i ? -1 : i; show(locked); });
    });
    Array.prototype.forEach.call(rows, function (r, i) {
      if (i > 3) return;
      r.addEventListener('mouseenter', hover(i));
      r.addEventListener('mouseleave', leave);
      r.addEventListener('click', function () { locked = locked === i ? -1 : i; show(locked); });
    });
  }

  /* ---------- Clarity: loupe ---------- */
  var loupes = [];
  function initClarity(fig) {
    if (fig.__edu) return; fig.__edu = true;
    var svg = fig.querySelector('[data-loupe-svg]');
    var area = fig.querySelector('[data-loupe-area]');
    var clip = svg.querySelector('[data-loupe-clip]');
    var glass = svg.querySelector('[data-loupe-glass]');
    var zoom = svg.querySelector('[data-loupe-zoom]');
    var ring = svg.querySelector('[data-loupe-ring]');
    var buttons = fig.querySelectorAll('.edu-fig__grade');
    var note = fig.querySelector('[data-grade-note]');
    var XS = [72, 216, 360, 504, 648], CY = 92, K = 3.2;
    var st = { x: 360, target: 360, pointer: false, pinned: -1, active: 2, raf: 0 };

    function place(x) {
      var xx = Math.round(x * 10) / 10;
      clip.setAttribute('cx', xx); glass.setAttribute('cx', xx);
      ring.setAttribute('transform', 'translate(' + xx + ' ' + CY + ')');
      zoom.setAttribute('transform', 'translate(' + xx + ' ' + CY + ') scale(' + K + ') translate(' + (-xx) + ' ' + (-CY) + ')');
      var best = 0, d = 1e9;
      for (var i = 0; i < XS.length; i++) { var dd = Math.abs(XS[i] - x); if (dd < d) { d = dd; best = i; } }
      if (best !== st.active) setActive(best);
    }
    function setActive(i) {
      st.active = i;
      buttons.forEach(function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      if (note) note.textContent = buttons[i].getAttribute('data-note') || '';
    }
    function tick() {
      st.raf = 0;
      var dx = st.target - st.x;
      if (Math.abs(dx) < .3 || reduce) { st.x = st.target; place(st.x); return; }
      st.x += dx * .16; place(st.x);
      st.raf = requestAnimationFrame(tick);
    }
    function go(x) { st.target = Math.max(XS[0], Math.min(XS[4], x)); if (!st.raf) st.raf = requestAnimationFrame(tick); }
    function fromScroll() {
      if (st.pointer || st.pinned > -1 || reduce) return;
      var r = area.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) { st.pinned = -1; return; }
      // 0 when the figure enters the lower 15% of the screen, 1 when it reaches the upper 25%
      var p = (vh * .85 - r.top) / (vh * .6 + r.height * .5);
      p = Math.max(0, Math.min(1, p));
      go(XS[0] + (XS[4] - XS[0]) * p);
    }
    function svgX(e) {
      var r = svg.getBoundingClientRect();
      return (e.clientX - r.left) / r.width * 720;
    }
    area.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') return; st.pointer = true; st.pinned = -1; go(svgX(e)); });
    area.addEventListener('pointerleave', function () { st.pointer = false; fromScroll(); });
    area.addEventListener('click', function (e) {
      var x = svgX(e), best = 0, d = 1e9;
      for (var i = 0; i < XS.length; i++) { var dd = Math.abs(XS[i] - x); if (dd < d) { d = dd; best = i; } }
      st.pinned = best; go(XS[best]);
    });
    buttons.forEach(function (b, i) { b.addEventListener('click', function () { st.pinned = i; go(XS[i]); }); });
    place(st.x); setActive(2);
    loupes.push(fromScroll);
    fromScroll();
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; for (var i = 0; i < loupes.length; i++) loupes[i](); });
  }

  /* ---------- Illustrated tables: pictures <-> rows of the same table ---------- */
  function initLink(el) {
    if (el.__edu) return; el.__edu = true;
    var table = el.closest('.policy-table');
    var rows = table ? table.querySelectorAll('tbody tr') : [];
    var items = el.querySelectorAll('[data-row]');
    var readout = el.querySelector('[data-ill-readout]');
    if (table && rows.length) table.setAttribute('data-linked', '');
    var locked = -1;
    function show(i) {
      el.classList.toggle('has-on', i > -1);
      items.forEach(function (it) {
        var on = +it.getAttribute('data-row') === i;
        it.classList.toggle('is-on', on);
        if (it.tagName === 'BUTTON') it.setAttribute('aria-pressed', on && locked === i ? 'true' : 'false');
      });
      for (var r = 0; r < rows.length; r++) rows[r].classList.toggle('is-linked', r === i);
      if (readout) {
        var src = i > -1 ? el.querySelector('[data-row="' + i + '"][data-desc]') : null;
        readout.textContent = src ? src.getAttribute('data-desc') : '';
      }
    }
    function bind(node, i) {
      node.addEventListener('mouseenter', function () { if (locked < 0) show(i); });
      node.addEventListener('mouseleave', function () { show(locked); });
      node.addEventListener('click', function () { locked = locked === i ? -1 : i; show(locked); });
      node.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); locked = locked === i ? -1 : i; show(locked); } });
    }
    items.forEach(function (it) { if (it.tagName === 'BUTTON' || it.tagName === 'LI') bind(it, +it.getAttribute('data-row')); });
    Array.prototype.forEach.call(rows, function (r, i) { bind(r, i); });
  }

  /* ---------- Sizing helpers ---------- */
  function parseRows(el) { try { return JSON.parse(el.getAttribute('data-rows')) || []; } catch (e) { return []; } }
  function interp(rows, col, v) { // size (col 0) for a value in column col, linear between rows
    var r = rows.filter(function (x) { return x[col] > 0; }).sort(function (a, b) { return a[col] - b[col]; });
    if (!r.length || v < r[0][col] - .25 * (r[1] ? r[1][col] - r[0][col] : 1) || v > r[r.length - 1][col] + .25 * (r.length > 1 ? r[r.length - 1][col] - r[r.length - 2][col] : 1)) return null;
    if (v <= r[0][col]) return r[0][0] - (r[0][col] - v) / ((r[1] || r[0])[col] - r[0][col] || 1) * ((r[1] || r[0])[0] - r[0][0]);
    for (var i = 1; i < r.length; i++) if (v <= r[i][col]) return r[i - 1][0] + (v - r[i - 1][col]) / (r[i][col] - r[i - 1][col]) * (r[i][0] - r[i - 1][0]);
    var a = r[r.length - 2] || r[0], z = r[r.length - 1];
    return z[0] + (v - z[col]) / (z[col] - a[col] || 1) * (z[0] - a[0]);
  }
  function quarter(n) {
    var q = Math.round(n * 4) / 4, w = Math.floor(q), f = q - w;
    return (w || '') + (f === .25 ? '¼' : f === .5 ? '½' : f === .75 ? '¾' : '') || '0';
  }
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Ring sizer ---------- */
  function initRing(el) {
    if (el.__rs) return; el.__rs = true;
    var rows = parseRows(el);
    var tpl = el.getAttribute('data-result') || '[size]', outside = el.getAttribute('data-range') || '';
    var tabs = el.querySelectorAll('[data-rs-tab]'), panes = el.querySelectorAll('[data-rs-pane]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.getAttribute('data-rs-tab');
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panes.forEach(function (p) { p.hidden = p.getAttribute('data-rs-pane') !== k; });
        if (k === 'ring') drawRing();
      });
    });
    // screen setup: CSS px per real millimetre, matched against a bank card's short edge (53.98 mm, ISO/IEC 7810 ID-1)
    var CARD = 53.98;
    var pxmm = parseFloat(store.get('fz-pxmm')) || 96 / 25.4;
    var cal = el.querySelector('[data-rs-cal]'), meas = el.querySelector('[data-rs-measure]');
    var line = el.querySelector('[data-rs-line]'), scale = el.querySelector('[data-rs-scale]');
    var circle = el.querySelector('[data-rs-circle]'), dia = el.querySelector('[data-rs-dia]'), out = el.querySelector('[data-rs-result]');
    var ds = rows.map(function (r) { return r[1]; }).filter(Boolean);
    var minD = Math.min.apply(null, ds) - 1, maxD = Math.max.apply(null, ds) + 1;
    dia.min = minD.toFixed(1); dia.max = maxD.toFixed(1);
    var mid = rows[Math.floor(rows.length / 2)]; dia.value = mid ? mid[1] : (minD + maxD) / 2;
    function drawLine() { line.style.width = (CARD * pxmm).toFixed(1) + 'px'; }
    scale.value = pxmm.toFixed(2);
    scale.addEventListener('input', function () { pxmm = parseFloat(scale.value); drawLine(); });
    drawLine();
    if (store.get('fz-pxmm')) { cal.hidden = true; meas.hidden = false; }
    el.querySelector('[data-rs-done]').addEventListener('click', function () { store.set('fz-pxmm', String(pxmm)); cal.hidden = true; meas.hidden = false; drawRing(); });
    el.querySelector('[data-rs-recal]').addEventListener('click', function () { cal.hidden = false; meas.hidden = true; });
    function drawRing() {
      var d = parseFloat(dia.value);
      circle.style.width = circle.style.height = (d * pxmm).toFixed(1) + 'px';
      var sz = interp(rows, 1, d);
      out.innerHTML = sz == null ? outside : tpl.replace('[size]', '<b>' + quarter(sz) + '</b>') + ' <span>· ' + d.toFixed(1) + ' mm</span>';
    }
    dia.addEventListener('input', drawRing);
    // finger
    var circ = el.querySelector('[data-rs-circ]'), unit = el.querySelector('[data-rs-unit]'), fout = el.querySelector('[data-rs-fresult]');
    function finger() {
      var v = parseFloat(circ.value);
      if (!(v > 0)) { fout.textContent = ''; return; }
      var mm = unit.value === 'in' ? v * 25.4 : v;
      var sz = interp(rows, 2, mm);
      fout.innerHTML = sz == null ? outside : tpl.replace('[size]', '<b>' + quarter(sz) + '</b>') + ' <span>· ' + mm.toFixed(1) + ' mm</span>';
    }
    circ.addEventListener('input', finger); unit.addEventListener('change', finger);
    drawRing();
  }

  /* ---------- Bracelet fit ---------- */
  function initBracelet(el) {
    if (el.__bz) return; el.__bz = true;
    var rows = parseRows(el); if (!rows.length) return;
    var wrist = el.querySelector('[data-bz-wrist]'), close = el.querySelector('[data-bz-close]'), relaxed = el.querySelector('[data-bz-relaxed]');
    var cOut = el.querySelector('[data-bz-close-out]'), rOut = el.querySelector('[data-bz-relaxed-out]');
    var input = el.querySelector('[data-bz-input]'), unit = el.querySelector('[data-bz-unit]'), msg = el.querySelector('[data-bz-msg]');
    var maxL = Math.max.apply(null, rows.map(function (r) { return Math.max(r[1] || 0, r[2] || 0); })) + .5;
    var K = 104 / (maxL / Math.PI * 1.08); // svg units per inch: the longest loop fits the 124-unit frame
    var TOP = -44;
    var fmt = function (n) { return quarter(n) + ' in'; };
    // Ramanujan ellipse perimeter
    function per(a, b) { return Math.PI * (3 * (a + b) - Math.sqrt((3 * a + b) * (a + 3 * b))); }
    function draw(w, c, r) {
      // wrist cross-section ~1.35:1, perimeter = wrist measurement
      var b = w / 7.424, a = b * 1.35;
      wrist.setAttribute('rx', (a * K).toFixed(2)); wrist.setAttribute('ry', (b * K).toFixed(2));
      wrist.setAttribute('cy', (TOP + b * K).toFixed(2));
      // a chain rests on top of the wrist and its slack hangs below: an ellipse sharing the top point,
      // a little wider and deeper, solved so its perimeter equals the bracelet length
      [[close, c], [relaxed, r]].forEach(function (p) {
        var L = p[1], lo = 0, hi = 3;
        for (var k = 0; k < 40; k++) { var m = (lo + hi) / 2; if (per(a + m * .35, b + m) < L) lo = m; else hi = m; }
        var e = (lo + hi) / 2, A = (a + e * .35) * K, B = (b + e) * K;
        p[0].setAttribute('rx', A.toFixed(2)); p[0].setAttribute('ry', B.toFixed(2)); p[0].setAttribute('cy', (TOP + B).toFixed(2));
      });
      cOut.textContent = fmt(c); rOut.textContent = fmt(r);
    }
    function nearest(w) {
      var best = 0, d = 1e9;
      rows.forEach(function (r, i) { var dd = Math.abs(r[0] - w); if (dd < d) { d = dd; best = i; } });
      return best;
    }
    function fromRow(i) { var r = rows[i]; draw(r[0], r[1], r[2]); }
    function fromInput() {
      var v = parseFloat(input.value); if (!(v > 0)) { msg.textContent = ''; return; }
      var w = unit.value === 'cm' ? v / 2.54 : v;
      var lo = Math.min.apply(null, rows.map(function (x) { return x[0]; })), hi = Math.max.apply(null, rows.map(function (x) { return x[0]; }));
      if (w < lo - 1 || w > hi + 1) { msg.textContent = el.getAttribute('data-range') || ''; return; }
      msg.textContent = '';
      var i = nearest(w), r = rows[i];
      draw(w, w + (r[1] - r[0]), w + (r[2] - r[0]));
      var chip = el.querySelector('.edu-ill__chip[data-row="' + i + '"]');
      if (chip && !chip.classList.contains('is-on')) chip.click();
      draw(w, w + (r[1] - r[0]), w + (r[2] - r[0]));
    }
    el.querySelectorAll('.edu-ill__chip').forEach(function (ch) {
      ch.addEventListener('click', function () { fromRow(+ch.getAttribute('data-row')); });
      ch.addEventListener('mouseenter', function () { fromRow(+ch.getAttribute('data-row')); });
    });
    input.addEventListener('input', fromInput); unit.addEventListener('change', fromInput);
    fromRow(Math.min(2, rows.length - 1));
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ring-sizer]').forEach(initRing);
    (scope || document).querySelectorAll('[data-bracelet]').forEach(initBracelet);
    (scope || document).querySelectorAll('[data-edu-link]').forEach(initLink);
    (scope || document).querySelectorAll('[data-edu-fig="color"]').forEach(initColor);
    (scope || document).querySelectorAll('[data-edu-fig="clarity"]').forEach(initClarity);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { loupes.length = 0; init(e.target); onScroll(); });
})();
